import queryString from 'query-string'

export const getCurrentPage = (query: string) => {
  const pageParam = queryString.parse(query).page
  if (pageParam && !Array.isArray(pageParam)) {
    return parseInt(pageParam, 10)
  }
  return 1
}
